import { createFileRoute } from "@tanstack/react-router";

import { SPECIFICATIONS_BASE_PATH, legacyRedirectTo } from "@/lib/route-paths";

// Legacy bookmark: the old stack's `/specs` is the new `/specifications`.
// The hop through `/specifications` is deliberately collapsed — the
// observable destination is the contract term, not the path taken to it.
//
// Directory, not a flat `specs.tsx`, so the Specifications slice can add the
// data-dependent `/specs/:id/*` aliases beside this file without turning it
// into their layout route.
export const Route = createFileRoute("/_authed/_chrome/specs/")({
  beforeLoad: legacyRedirectTo(SPECIFICATIONS_BASE_PATH),
});
